(function(window) {
    if ($('.site-header').length <= 0) {
        return;
    }

    var megaNav = function() {
        var menuStack = [];
        var ui = {};
        var isMobile;
        var SHOW_CSS = '-open';
        var OVERLAY = 'overlay';
        var NO_SCROLL = 'noscroll';
        var MEDIA_QUERY = '(max-width: 991px)';
        var mql = window.matchMedia(MEDIA_QUERY);

        function cacheUI() {
            ui.$body = $('body');
            ui.$siteHeader = $('[data-region="site-header"]');
            ui.$nav = $('[data-region="main-nav"]');
            ui.$subMenu = $('[data-region="menu"]');
            ui.$hamburger = $('[data-control="mobile-menu"]');
            ui.$closeBtn = $('[data-control="closemobilemenu"]');
            ui.$openSubnav = $('[data-control="subnav-toggle-lr"]');
            ui.$openSubnavl2 = $('[data-control="subnav-toggle-l1"]');
            ui.$subnavlevel1 = $('[data-region="nav-lr"]');
            ui.$backBtn = $('[data-control="back"]');

            ui.$navToggler = $('.js-submenu-toggler');
            ui.$mobileClicktoggler = $('.has-children');
            ui.$sidebar = $('.mega-menu-sidebar');
            ui.$megaSidebarNavItem = $('.js-sidebar-item');
            ui.$megaPanel = $('.mega-menu-panel');
            ui.$sidebarNavToggler = $('.js-sidebar-toggler');
            ui.$bodyOpen = $('body.noscroll');
            ui.$simpleToggler = $('.mega-simple-dropdown .js-simplemenu-item');
        }

        function showMobileMenu() {
            event.stopPropagation();
            ui.$nav.addClass(SHOW_CSS);
            ui.$body.addClass(NO_SCROLL);
        }

        function hideMobileMenu() {
            ui.$nav.removeClass(SHOW_CSS);
            ui.$body.removeClass(NO_SCROLL);
            ui.$nav.find('.-active').removeClass('-active');
            ui.$bodyOpen.off('click', hideMobileMenu);
        }

        function checkMenuOpen(e) {
            if (!ui.$body.hasClass(NO_SCROLL)) {
                return;
            }
            if (!$(e.target).closest(ui.$nav).length) {
                hideMobileMenu();
            }
        }

        function closeMegaMenu(e) {
            ui.$nav.find('.active').removeClass('active');
        }

        function toggleMegaRoot(e) {
            isMobile = mql.matches ? true : false;
            if (isMobile) {
                e.preventDefault();
                var $target = $(e.target);
                ui.$subnavlevel1.removeClass('-active');
                $target.closest('li').addClass('-active');
            } else {
                e.preventDefault();
                e.stopPropagation();
                var $target = $(e.target);
                ui.$subnavlevel1.removeClass('-active');
                $target.closest('li').addClass('-active');
                $('body').on('click', function(event) {
                    closeMegaRoot(event);
                });
            }
        }

        function closeMegaRoot(event) {
            isMobile = mql.matches ? true : false;
            if (!isMobile) {
                ui.$subnavlevel1.removeClass('-active');
                $('body').off('click', function(event) {
                    checkMenuOpen(event);
                });
            }
        }

        function checkMenuOpen(event) {
            if (!$(event.target).parents('[data-region="main-nav"]').length) {
                removeActives();
            }
        }

        function toggleMegaSub(e) {
            e.preventDefault();
            var $target = $(e.target);
            ui.$subMenu.find('.-active').removeClass('-active');
            $target.closest('li').addClass('-active');
        }

        function removeActives() {
            ui.$nav.find('.-active').removeClass('-active');
        }

        function mobileBackBtn(e) {
            if (mql.matches) {
                e.preventDefault();
                var $target = $(e.target);
                $target.closest('.-subnav').removeClass('-active');
            }
        }

        var yourNavigation = $('.site-header');
        stickyDiv = 'isSticky';
        yourHeader = $('.site-header').height();

        $(window).scroll(function() {
            if ($(this).scrollTop() > yourHeader) {
                yourNavigation.addClass(stickyDiv);
            } else {
                yourNavigation.removeClass(stickyDiv);
            }
        });

        $('.utility-nav__item').hover(
            function() {
                $(this).addClass('-active');
            },
            function() {
                $('.utility-nav__item').removeClass('-active');
            }
        );

        $('.mobile-utility-nav__link.-dropdown').on('click', function(event) {
            event.preventDefault();

            let dropdownUl = event.target.nextElementSibling;

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(dropdownUl).removeClass('active');
            } else {
                let activeButtons = $('.-subnav.active');
                if (activeButtons) {
                    $(activeButtons).removeClass('active');
                    $('.utility-dropdown.active').removeClass('active');
                }
                $(this).addClass('active');
                $(dropdownUl).addClass('active');
            }
        });

        function handleMediaQueryChange(mql) {
            isMobile = mql.matches ? true : false;
            if (isMobile) {
                ui.$nav.find('.active').removeClass('active');
            } else {
                hideMobileMenu();
            }
        }

        $('#google_translate_element-mobile').on('click', function(event) {
            event.preventDefault();
            var $head = $('.VIpgJd-ZVi9od-xl07Ob-OEVmcd')
                .contents()
                .find('head');
            var css =
                '<style type="text/css">' +
                '@media only screen and (max-width: 992px) { .VIpgJd-ZVi9od-vH1Gmf{max-width: 100% !important; overflow-x: scroll !important;}}; ' +
                '</style>';
            jQuery($head).append(css);

            let translateButton = $('#google_translate_element > div > div');
            $(translateButton).click();
        });

        function bindEvents() {
            ui.$hamburger.on('click', showMobileMenu);
            ui.$closeBtn.on('click', hideMobileMenu);
            ui.$openSubnav.on('click', toggleMegaRoot);
            ui.$openSubnavl2.on('click', toggleMegaSub);
            ui.$nav.on('blur', removeActives);
            ui.$backBtn.on('click', mobileBackBtn);

            ui.$nav.on('focusout', function(e) {
                if (mql.matches) {
                    var $currentMega = $(e.target).closest(
                        '.site-header-main-nav-wrpper'
                    );
                    if ($currentMega.has(e.relatedTarget).length == 1) {
                        // don't react to this
                        return;
                    }
                    closeMegaMenu();
                }
            });
            mql.addListener(handleMediaQueryChange);
        }

        let ctaPlaceholder = document.querySelector(
            '.content-block__cta-placeholder'
        );
        if (ctaPlaceholder) {
            if (ctaPlaceholder.innerHTML == '') {
                ctaPlaceholder.remove();
            }
        }

        function init() {
            cacheUI();
            bindEvents();
            handleMediaQueryChange(mql);
        }

        return {
            init: init,
        };
    };

    var menu = megaNav();
    menu.init();
})(window);
